<script>
import { Line } from "vue-chartjs";
import Chart from "chart.js";
const TRANSICAO_CYCLE = 9;
const FUNDAMENTAL_CYCLES = [1, 2, 3, 10];
const EM_CYCLES = [4, 5];

const flagSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="5" fill="#36B67D"/>
<path d="M18.5 7.50001V15C18.4996 15.0712 18.484 15.1415 18.4543 15.2061C18.4245 15.2708 18.3813 15.3284 18.3275 15.375C17.3725 16.2019 16.4594 16.5 15.5887 16.5C14.4069 16.5 13.3031 15.9538 12.2762 15.4469C10.6169 14.625 9.17438 13.9131 7.5 15.2356V18C7.5 18.1326 7.44732 18.2598 7.35355 18.3536C7.25979 18.4473 7.13261 18.5 7 18.5C6.86739 18.5 6.74021 18.4473 6.64645 18.3536C6.55268 18.2598 6.5 18.1326 6.5 18V7.50001C6.50048 7.42878 6.51617 7.35847 6.54603 7.2938C6.57589 7.22913 6.61922 7.17158 6.67313 7.12501C8.92313 5.17626 10.9425 6.17439 12.7225 7.05501C14.4375 7.90376 15.9244 8.63751 17.6725 7.12501C17.7448 7.06238 17.8335 7.02178 17.9281 7.00802C18.0227 6.99427 18.1193 7.00793 18.2064 7.0474C18.2935 7.08687 18.3674 7.15049 18.4195 7.23071C18.4715 7.31093 18.4995 7.40439 18.5 7.50001Z" fill="white"/>
</svg>`;

const hashureSvg = `<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_5712_931)">
    <rect width="24" height="20" fill="#B23066" />
    <path d="M-1 -1L15 21" stroke="white" stroke-opacity="0.6" stroke-width="2" />
    <path d="M-9 -1L7 21" stroke="white" stroke-opacity="0.6" stroke-width="2" />
    <path d="M7 -1L23 21" stroke="white" stroke-opacity="0.6" stroke-width="2" />
    <path d="M15 -1L31 21" stroke="white" stroke-opacity="0.6" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="clip0_5712_931">
      <rect width="24" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>`;

const starSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M7.77896 7.04424L8.20737 7.30205L7.77896 7.04424C7.74825 7.09528 7.69814 7.13168 7.6401 7.14512L1.64005 8.53475C0.744185 8.74223 0.391202 9.82861 0.994014 10.523L5.03136 15.174C5.07041 15.219 5.08955 15.2778 5.0844 15.3373L4.55189 21.4731C4.47238 22.3892 5.39651 23.0606 6.24323 22.7019L11.9142 20.2994C11.969 20.2761 12.031 20.2761 12.0858 20.2994L17.7568 22.7019C18.6035 23.0606 19.5276 22.3892 19.4481 21.4731L18.9156 15.3373C18.9104 15.2778 18.9296 15.219 18.9686 15.174L23.006 10.523C23.6088 9.8286 23.2558 8.74223 22.3599 8.53475L16.3599 7.14512C16.3019 7.13168 16.2518 7.09528 16.221 7.04424L13.0453 1.76726C12.5711 0.979361 11.4289 0.979362 10.9547 1.76726L7.77896 7.04424Z"
    fill="#FFBB00" stroke="#CC9600" />
</svg>`;

const exclamationSvg = `<svg width="24" height="24" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M479.548,265.753c-2.408-6.276-2.408-13.224,0-19.522l19.468-51.108c4.6-12.065,0.162-25.666-10.63-32.714 l-45.797-29.904c-5.635-3.682-9.719-9.317-11.471-15.801l-14.296-52.799c-3.366-12.443-14.96-20.865-27.828-20.224l-54.636,2.732 c-6.715,0.324-13.324-1.814-18.564-6.036L273.2,6.073c-10.035-8.097-24.361-8.097-34.404,0l-42.594,34.304 c-5.241,4.222-11.848,6.36-18.572,6.036l-54.629-2.732c-12.868-0.64-24.462,7.781-27.827,20.224l-14.288,52.799 c-1.76,6.484-5.843,12.119-11.478,15.801L23.61,162.408c-10.791,7.048-15.222,20.664-10.629,32.714l19.476,51.116 c2.401,6.291,2.401,13.238,0,19.521l-19.476,51.116c-4.593,12.042-0.162,25.666,10.629,32.714l45.798,29.912 c5.635,3.666,9.718,9.286,11.478,15.785l14.288,52.799c3.366,12.451,14.96,20.865,27.827,20.224l54.629-2.717 c6.724-0.348,13.331,1.806,18.572,6.021l42.594,34.319c10.043,8.09,24.369,8.09,34.396,0l42.602-34.319 c5.234-4.214,11.849-6.368,18.564-6.021l54.636,2.717c12.868,0.641,24.462-7.773,27.828-20.224l14.296-52.799 c1.752-6.499,5.836-12.119,11.471-15.785l45.797-29.912c10.792-7.048,15.23-20.672,10.622-32.714L479.548,265.753z M288.778,369.127c0,10.451-8.476,18.943-18.927,18.943h-27.704c-10.452,0-18.935-8.492-18.935-18.943v-28.916 c0-10.452,8.483-18.943,18.935-18.943h27.704c10.451,0,18.927,8.491,18.927,18.943V369.127z M288.778,268.948 c0,10.452-8.476,18.928-18.927,18.928h-27.704c-10.452,0-18.935-8.476-18.935-18.928V142.879c0-10.467,8.483-18.943,18.935-18.943 h27.704c10.451,0,18.927,8.476,18.927,18.943V268.948z" fill="#DB3C3C" />
</svg>`;

let cachedFlagImage = null;
let cachedHashureImage = null;
let cachedStarImage = null;
let cachedExclamationImage = null;
let isImageLoading = { flag: false, hashure: false, star: false, exclamation: false };

function createCachedImage(svg, type) {
  return new Promise((resolve) => {
    if (
      (type === "flag" && cachedFlagImage) ||
      (type === "hashure" && cachedHashureImage) ||
      (type === "star" && cachedStarImage) ||
      (type === "exclamation" && cachedExclamationImage)
    ) {
      resolve(
        type === "flag"
          ? cachedFlagImage
          : type === "hashure"
            ? cachedHashureImage
            : type === "star"
              ? cachedStarImage
              : cachedExclamationImage
      );
      return;
    }

    if (isImageLoading[type]) {
      resolve(null);
      return;
    }

    isImageLoading[type] = true;
    const img = new Image();
    const blob = new Blob([svg], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);

    img.onload = () => {
      if (type === "flag") {
        cachedFlagImage = img;
      } else if (type === "hashure") {
        cachedHashureImage = img;
      } else if (type === "star") {
        cachedStarImage = img;
      } else {
        cachedExclamationImage = img;
      }
      URL.revokeObjectURL(url);
      isImageLoading[type] = false;
      resolve(img);
    };

    img.src = url;
  });
}

function getFaixaPosition(faixa) {
  if (faixa.includes("-")) {
    const [min, maxWithSymbol] = faixa.split("-");
    const max = maxWithSymbol.replace("%", "");
    return { min: parseInt(min) / 100, max: parseInt(max) / 100 };
  } else {
    const value = parseInt(faixa.replace("%", ""));
    return { min: value / 100, max: value / 100 };
  }
}

Chart.plugins.register({
  beforeDraw: async function (chart) {
    const lineChartId = document.getElementById("line-chart");
    if (!lineChartId) {
      return;
    }

    const ctx = chart.ctx;
    const chartArea = chart.chartArea;
    const percentages = chart.config.data.percentages || {
      faixa1: "25-35%",
      faixa2: "55-65%",
      faixa3: "100%",
    };

    const faixas = {
      faixa1: percentages.faixa1 ? getFaixaPosition(percentages.faixa1) : null,
      faixa2: percentages.faixa2 ? getFaixaPosition(percentages.faixa2) : null,
      faixa3: percentages.faixa3 ? getFaixaPosition(percentages.faixa3) : null,
    };

    // Carregar imagens se necessário
    await Promise.all([
      createCachedImage(flagSvg, "flag"),
      createCachedImage(hashureSvg, "hashure"),
      createCachedImage(starSvg, "star"),
      createCachedImage(exclamationSvg, "exclamation"),
    ]);

    // Iterar pelos pontos de dados para encontrar os que têm col_number
    const data = chart.data;
    const metadata = data.datasets[0].data;

    for (let i = 0; i < metadata.length; i++) {
      // Verificar se o ponto tem col_number
      const point = metadata[i];
      const cycleId = point.cycleId;
      const colNumber =
        typeof point === "object" && point !== null ? point.col_number : null;

      if (colNumber === null || colNumber === undefined) {
        continue
      }

      const xPos = chart.scales["x-axis-0"].getPixelForTick(i);
      const totalHeight = chartArea.bottom - chartArea.top;

      const drawHashura = (xPos, col) => {
        if (!cachedHashureImage) return;

        let faixaData;
        if (col === 1) {
          faixaData = faixas.faixa1;
        } else if (col === 2) {
          faixaData = faixas.faixa2;
        } else if (col === 3) {
          faixaData = faixas.faixa3;
        }

        if (faixaData && faixaData.min !== faixaData.max) {
          const hashureY = chartArea.top + totalHeight * (1 - faixaData.max);
          const rangeHeight = (faixaData.max - faixaData.min) * totalHeight;

          if (rangeHeight > 0) {
            ctx.drawImage(
              cachedHashureImage,
              xPos - 10,
              hashureY,
              20,
              rangeHeight
            );
          }
        }
      }

      // Desenhar linha vertical
      ctx.save();
      ctx.beginPath();
      ctx.strokeStyle = "rgba(178, 48, 102, 0.37)";
      ctx.lineWidth = 20;
      ctx.moveTo(xPos, chartArea.bottom);
      ctx.lineTo(xPos, chartArea.top);
      ctx.stroke();
      ctx.restore();

      if (colNumber < 0) {
        // Desenhar bandeira e exclamação lado a lado
        if (cachedFlagImage && cachedExclamationImage) {
          const iconSize = 20;
          const iconY = 2;
          const spacing = 2; // Espaçamento entre os ícones

          // Desenhar bandeira à esquerda
          ctx.drawImage(cachedFlagImage, xPos - iconSize - spacing / 2, iconY, iconSize, iconSize);

          // Desenhar exclamação à direita
          ctx.drawImage(cachedExclamationImage, xPos + spacing / 2, iconY, iconSize, iconSize);

          // Desenhar texto abaixo dos ícones
          ctx.save();
          ctx.fillStyle = "#666666";
          ctx.font = "700 12px Arial";
          ctx.textAlign = "center";
          ctx.textBaseline = "top";
          ctx.fillText(`${Math.abs(colNumber)}º Ano`, xPos, iconY + iconSize + 5);
          ctx.restore();
        }

        const absCol = Math.abs(colNumber);
        drawHashura(xPos, absCol);

        continue;
      }

      // Desenhar bandeira
      if (cachedFlagImage) {
        const flagHeight = 20;
        const flagY = 2;

        ctx.drawImage(cachedFlagImage, xPos - 10, flagY, 20, flagHeight);

        ctx.save();
        ctx.fillStyle = "#666666";
        ctx.font = "700 12px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "top";
        ctx.fillText(`${colNumber}º Ano`, xPos, flagY + flagHeight + 5);
        ctx.restore();
      }

      // Determinar se deve mostrar estrela ou hashura
      if (
        (colNumber == 1 && cycleId == TRANSICAO_CYCLE && cachedStarImage) ||
        (FUNDAMENTAL_CYCLES.includes(cycleId) &&
          colNumber == 2 &&
          cachedStarImage) ||
        (colNumber >= 3 && EM_CYCLES.includes(cycleId) && cachedStarImage)
      ) {
        // Mostrar estrela no topo
        ctx.drawImage(cachedStarImage, xPos - 12, chartArea.top - 12, 24, 24);
      } else {
        drawHashura(xPos, colNumber);
      }
    }
  },
});

export default {
  name: "UiLineChart",
  extends: Line,
  props: {
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    currentYear: {
      type: Number,
      default: 1,
    },
    percentages: {
      type: Object,
      default: () => ({
        faixa1: "25-35%",
        faixa2: "55-65%",
        faixa3: "100%",
      }),
    },
  },
  data() {
    return {
      defaultOptions: {
        responsive: true,
        maintainAspectRatio: false,
        width: "100%",
        elements: {
          line: {
            tension: 0,
            borderColor: "#36b67d",
            borderWidth: 3,
          },
          point: {
            radius: 1,
            borderColor: "#36b67d",
            backgroundColor: "#36b67d",
            borderWidth: 10,
            hitRadius: 10,
          },
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                drawBorder: false,
              },
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 100,
                callback: (value) => {
                  return `${value}%`;
                },
                padding: 12,
              },
            },
          ],
          xAxes: [
            {
              position: "top",
              gridLines: {
                display: false,
              },
              ticks: {
                padding: 20,
                callback: () => {
                  return "";
                },
              },
            },
            {
              gridLines: {
                display: false,
              },
              ticks: {
                padding: 20,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItem) => {
              const yValue = tooltipItem.yLabel;
              return `${yValue}%`;
            },
            title: (tooltipItem, data) => {
              return data.labels[tooltipItem[0].index];
            },
          },
        },
      },
    };
  },
  mounted() {
    // Preparar dados para o gráfico, preservando col_number
    const chartData = {
      currentYear: this.currentYear,
      percentages: this.percentages,
      labels: this.data.labels || [],
      datasets: this.data.datasets.map((dataset, datasetIndex) => {
        // Transformar dados para manter col_number nos pontos
        const transformedData = dataset.data.map((item) => {
          // Se já for um objeto, manter como está
          if (typeof item === "object" && item !== null) {
            return item;
          }
          // Se for um número, converter para objeto com propriedade y
          return {
            y: item,
          };
        });

        const modifiedDataset = {
          ...dataset,
          data: transformedData,
        };

        if (datasetIndex === this.data.datasets.length - 1) {
          modifiedDataset.pointBackgroundColor = "#36b67d";
          modifiedDataset.pointBorderColor = "#36b67d";
          modifiedDataset.pointRadius = 0.1;
        }

        return {
          ...modifiedDataset,
          borderColor: "#36b67d",
          backgroundColor: "transparent",
          fill: false,
        };
      }),
    };

    const finalOptions = {
      ...this.defaultOptions,
      ...this.options,
    };

    this.renderChart(chartData, finalOptions);
  },
};
</script>

<style scoped>
canvas {
  background-color: transparent !important;
}
</style>
